<template>

    <form ref="colaborador-form-create" v-on:submit.prevent="executeCreate(model)" novalidate>

        <div class="row">


            <div class="form-group col-md-8">
                <label for="nmCompleto">Nome Completo</label>
                <input type="text" class="form-control" name="nmCompleto" autocomplete="off" placeholder="Nome Completo" v-model="model.nmCompleto" maxlength="80" required />
            </div>
            <div class="form-group col-md-4">
                <label for="apelido">Prefiro ser chamado de</label>
                <input type="text" class="form-control" name="apelido" autocomplete="off" placeholder="Apelido" v-model="model.apelido" maxlength="30" required />
            </div>

            <div class="form-group col-md-4">
                <label for="email">E-mail</label>
                <input type="email" class="form-control" name="email" autocomplete="off" placeholder="E-mail" v-model="model.email" maxlength="80" required />
            </div>
            <div class="form-group col-md-4">
                <label for="emailAlternativo">E-mail Alternativo</label>
                <input type="email" class="form-control" name="emailAlternativo" autocomplete="off" placeholder="E-mail Alternativo" maxlength="80" v-model="model.emailAlternativo" />
            </div>
            <div class="form-group col-md-4">
                <label for="dtNascimento">Nascimento</label>
                <input type="text" v-datepicker class="form-control" autocomplete="off" name="dtNascimento" placeholder="Data de Nascimento" v-model="model.dtNascimento" required />
            </div>

            <div class="form-group col-md-4">
                <label for="cpf">CPF</label>
                <input type="text" class="form-control" :disabled="cpfCarregado" name="cpf" v-mask="mask_cpf" maxlength="14" autocomplete="off" placeholder="___.___.___-__" v-model="model.cpf" required />
            </div>
            <div class="form-group col-md-4">
                <label for="rg">RG</label>
                <input type="text" class="form-control" v-mask="mask_rg" name="rG" autocomplete="off" maxlength="20" placeholder="__.___.___-_" v-model="model.rg" required />
            </div>
            <div class="form-group col-md-4">
                <label for="sexo">Sexo</label>
                <select v-model="model.sexo" class="form-control" name="sexo" required>
                    <option value="">Selecione</option>
                    <option value="M">Masculino</option>
                    <option value="F">Feminino</option>
                </select>
            </div>
            <div class="form-group col-md-1">
                <label for="telefoneDDD">DDD</label>
                <input type="tel" class="form-control" name="telefoneDDD" :required="!model.celularDDD && !model.comercialDDD && !model.telefoneDDD"  v-mask="'##'" maxlength="2" autocomplete="off" placeholder="__" v-model="model.telefoneDDD" />
            </div>
            <div class="form-group col-md-3">
                <label for="telefoneNumero">Telefone Residencial</label>
                <input type="text" class="form-control" name="telefoneNumero" :required="!model.celularNumero && !model.telefoneNumero && !model.telefoneComercial" v-mask="mask_tel" maxlength="10" autocomplete="off" placeholder="____-____" v-model="model.telefoneNumero" />
            </div>
            <div class="form-group col-md-1">
                <label for="ComercialDDD">DDD</label>
                <input type="tel" class="form-control" name="comercialDDD" :required="!model.celularDDD && !model.comercialDDD && !model.telefoneDDD"  v-mask="'##'" maxlength="2" autocomplete="off" placeholder="__" v-model="model.comercialDDD" />
            </div>
            <div class="form-group col-md-3">
                <label for="telefoneComercial">Telefone/Celular Comercial</label>
                <input type="text" class="form-control" name="telefoneComercial" :required="!model.celularNumero && !model.telefoneNumero && !model.telefoneComercial" v-mask="mask_cel" maxlength="10" autocomplete="off" placeholder="____-____" v-model="model.telefoneComercial" />
            </div>
            <div class="form-group col-md-1">
                <label for="celularDDD">DDD</label>
                <input type="text" class="form-control" name="celularDDD" :required="!model.celularDDD && !model.comercialDDD && !model.telefoneDDD"  v-mask="'##'" maxlength="2" autocomplete="off" placeholder="__" v-model="model.celularDDD" />
            </div>
            <div class="form-group col-md-3">
                <label for="celularNumero">Celular</label>
                <input type="text" class="form-control" name="celularNumero" :required="!model.celularNumero && !model.telefoneNumero && !model.telefoneComercial" v-mask="mask_cel" maxlength="10" autocomplete="off" placeholder="_____-____" v-model="model.celularNumero" />
            </div>
            <div class="form-group col-md-2">
                <div class="clearfix">&nbsp;</div>
                <label class="custom-control custom-checkbox">
                    <input type="checkbox" name="ehEstrangeiro" class="custom-control-input" v-model="model.ehEstrangeiro">
                    <span class="custom-control-indicator"></span>
                    <span class="custom-control-description"> Estrangeiro?</span>
                </label>
            </div>
            <div class="form-group col-md-10" v-if="model.ehEstrangeiro">
                <label for="nacionalidadeId">Nacionalidade</label>
                <select v-select="{ dataitem: 'Nacionalidade', default: 'Selecione' }" v-model="model.nacionalidadeId" class="form-control" name="nacionalidadeId" required></select>
            </div>


        </div>

        <button type="button" class="btn btn-default" @click="onBack()">
            <span>Voltar</span>
        </button>
        <button type="button" class="btn btn-success float-right" @click="executeCreate(model)">
            <span>Salvar</span>
        </button>

    </form>


</template>
<script>

    import base from '@/common/base.js'
    import { Api } from '@/common/api'

    export default {
        name: "colaborador-form-create",
        mixins: [base],
        props: { cpf: String },
        data: () => ({

            cpfCarregado: false,

            model: {
                nacionalidadeId: "",
                sexo: "",
            },

            form: "colaborador-form-create",

            resources: {
                create: 'colaborador',
            },

        }),

        methods: {

            executeCreate: function (model) {
                if (this.formValidate() == false)
                    return;

                if (this.model.telefoneNumero) model.telefoneNumero = model.telefoneNumero.replace(/\D+/g, '');
                if (this.model.celularNumero) model.celularNumero = model.celularNumero.replace(/\D+/g, '');

                model.cpf = model.cpf.replace(/\D+/g, '');
                model.rg = model.rg.replace(/\D+/g, '');

                this.showLoading();

                new Api(this.resources.create).post(model).then(data => {
                    this.$emit('on-saved', data.data)
                    this.defaultSuccessResult('Registro inserido com sucesso');
                }, err => {
                    this.defaultErrorResult(err);
                })
            },

            formValidate: function () {
                var $form = this.$refs[this.form];
                $form.classList.add("was-validated");
                var _valid = $form.checkValidity();
                if (!_valid) this.defaultErrorResult("Preencha todos os campos obrigatórios");
                return _valid;
            },

            onBack: function () {
                this.$emit('on-back')
            }
        },

        mounted() {
            if (this.cpf) {
                this.model.cpf = this.cpf;
                this.cpfCarregado = true;
            }
        }
    };
</script>

